// extracted by mini-css-extract-plugin
export default {"main":"index_main_Nvs-7 clearfix w1000"};